import { Box } from "@mui/material";

// Card #3296 -- the rider's equitation section as the show names it ("Heat B"),
// shown as quiet secondary text beside the rider. `section` is already
// formatted (orderOfGo.js rideSectionText -> score-common formatSection); a
// rider not drawn has "" and this renders nothing at all.
export default function SectionTag({ section, sx }) {
  if (!section) return null;
  return (
    <Box
      component="span"
      data-testid="ride-section"
      sx={{ color: "text.secondary", fontWeight: 600, ml: 1, whiteSpace: "nowrap", ...sx }}
    >
      {section}
    </Box>
  );
}
